<template>
  <v-app>
    <NuxtLayout>
      <NuxtPage />
      <ToastNotification />
      <v-scale-transition>
        <AlertDialog />
      </v-scale-transition>
    </NuxtLayout>
  </v-app>
</template>

<script setup>
// This is the main app entry point
// v-app is required for Vuetify to work properly
import ToastNotification from '~/components/ToastNotification.vue';
import AlertDialog from '~/components/AlertDialog.vue';
import { useAppTheme } from '~/composables/useTheme';

useHead({
  title: 'INDA (Independent Assessor)'
});

// Initialize theme globally for all pages to ensure Vuetify syncs with server-detected theme
const _theme = useAppTheme();

// The server plugin applies the theme immediately, but we need to sync Vuetify
onMounted(() => {
  // This ensures Vuetify theme is properly initialized on all pages
  // The theme composable will read the server-detected theme and sync Vuetify
});
</script>
